export const name = 'gzGoogleAddress';
export default function gzGoogleAddress(
  $window
) {
  'ngInject';

  let directive = {
    restrict: 'EA',
    scope: {
      pairingId: '@?',
      options: '=',
      onMapClicked: '&?',
    },
    template: require('./google-address.jade'),
    link: googleAddressLink,
    controller: googleAddressController,
    controllerAs: 'vm',
    bindToController: true,
  };
  return directive;

  //////////////////////

  function googleAddressLink(scope, element) {
    // Add this method to the scope to be invoked with ng-init
    // when the spacer element is added to the DOM. This ensures the elements are present.
    scope.vm.watchSpacer = () => {
      let el = element[0];
      if (el.parentElement) {
        // If we have a parent element, let's use that for sizing
        el = el.parentElement;
      }

      let map = el.querySelector('.map');
      let formContainer = el.querySelector('.form-container');
      let spacer = el.querySelector('.spacer');

      toggleSpacer();
      $window.addEventListener('resize', toggleSpacer);
      scope.$on('$destroy', () => {
        $window.removeEventListener('resize', toggleSpacer);
      });

      function toggleSpacer() {
        if (scope.vm.manualMode) {
          return;
        }

        // Hilarious: parseInt() by definition will stop parsing on first non-number character.
        // So "300px" is parsed to 300. Incredible.
        let mapMinWidth = $window.parseInt($window.getComputedStyle(map).getPropertyValue('min-width'), 10);
        let formContainerMinWidth = $window.parseInt($window.getComputedStyle(formContainer).getPropertyValue('min-width'), 10);
        if (el.clientWidth < (mapMinWidth + formContainerMinWidth)) {
          // Wrapping so remove spacer
          spacer.classList.add("hidden");
        } else {
          spacer.classList.remove("hidden");
        }
      }
    };
  }

  /** @ngInject */
  function googleAddressController(
    rnHttp,
    rnLocale,
    $gzGoogleMaps,
    $gzTime,
    $window,
    $rootScope,
    $timeout,
    $q,
    $mdDialog
  ) {
    // Constants
    const US_VALIDATORS = {
      region: {
        maxlength: 2,
        validator: 'Validator.AAA.USState'
      },
      postalCode: {
        required: true,
        maxlength: 10,
        validator: 'Validator.AAA.USPostalCode'
      }
    };
    const CANADA_VALIDATORS = {
      region: {
        maxlength: 2,
        validator: 'Validator.AAA.CAProvidences'
      },
      postalCode: {
        required: true,
        maxlength: 7,
        validator: 'Validator.AAA.CAPostalCode'
      }
    };
    const DEFAULT_VALIDATORS = {
      region: {
        maxlength: 100,
        validator: 'Validator.AAA.DescriptionUnicode'
      },
      postalCode: {
        required: false,
        maxlength: 35,
        validator: 'Validator.AAA.PostalCode'
      }
    };
    const US_COUNTRY_CODE = 'US';
    const CANADA_COUNTRY_CODE = 'CA';

    // Variables
    let updateGuessDebounceTimer;

    let defaultTimeZone;
    let isInitialized = false; // Ready for place handlers (map ready, address initialized)
    let markers = []; // Store markers currently on the map for clean up
    let addresses = []; // Address book addresses

    // View Model
    let vm = this;
    vm.loading = true;  // Cleared once we get dependent data
    vm.manualMode = false; // Applies to Edit Mode, whether or not to display the form (true) or map (false)
    vm.editMode = true; // Whether or not to show address edit controls (true) or display map only (false)
    vm.validators = DEFAULT_VALIDATORS; // Current set of validation depending on selected country

    vm.handleMapReady = handleMapReady; // Google map control is initialized with map object
    vm.useBrowserLocation = useBrowserLocation; // Use browser location services to set location
    vm.useGuessLocation = useGuessLocation; // Use our best guess location
    vm.handlePlaceChanged = handlePlaceChanged; // Location field place changed
    vm.handlePlaceTextChanged = handlePlaceTextChanged; // Location field place text changed
    vm.toggleView = toggleView; // Switch between map and form mode (editMode ONLY)
    vm.openAddresses = openAddresses; // Open select Address Book dialog
    vm.countryChanged = countryChanged; // Set validation based on country
    vm.isIncompletePlace = isIncompletePlace;

    // API
    // setAddress -
    // getAddress -

    vm.$onInit = onInit;
    return;

    function onInit() {
      vm.mapsSupported = $gzGoogleMaps.mapsSupported;
      if (!vm.mapsSupported) {
        vm.manualMode = true;
      }

      parseOptions();
      setupAPI();

      if (vm.editMode) {
        let promises = [];
        promises.push(getTimeZones());
        promises.push(getCountries());
        promises.push(getAddresses());
        return $q.all(promises).finally(() => {
          vm.loading = false;
        });
      }
      else {
        vm.loading = false;
        return $q.resolve();
      }
    }

    ///////////////////////////////////////////////////////////
    // Activate
    function parseOptions() {
      vm.hideName = _.get(vm.options, 'hideNameField', false);
      vm.name = _.get(vm.options, 'name');
      vm.address = _.get(vm.options, 'address');
      vm.timezone = _.get(vm.options, 'timezone', defaultTimeZone);
      vm.editMode = !_.get(vm.options, 'displayMode', false);
    }

    function setupAPI() {
      _.set(vm.options, 'api.isValid', isValid);
      _.set(vm.options, 'api.getAddress', getAddress);
      _.set(vm.options, 'api.setAddress', setAddress);
    }

    function getTimeZones() {
      return $gzTime.getTimeZones().then(timezones => {
        vm.timezones = timezones;
        return $gzTime.getPreferredTimeZone().then(tz => {
          if (!vm.timezone) {
            vm.timezone = tz;
          }
        });
      }).catch(error => {
      });
    }

    function getCountries() {
      return rnLocale.getBestFit()
        .then(locale => {
          let portalCountriesOpts = {
            cache: true,
            params: {
              locale: locale.value
            }
          };

          return rnHttp.get('portal_service', 'preferences/countries', portalCountriesOpts)
            .then(response => {
              vm.countries = response.data;
            });
        });
    }

    function getAddresses() {
      return rnHttp.get('aaa', `organizations/addresses/`).then(resp => {
        addresses = _.get(resp, 'data.addresses', []);
        if (addresses.length > 0) {
          vm.showAddressBook = true;
        }
      });
    }


    ///////////////////////////////////////////////////////////
    // Handlers
    function handleMapReady() {
      vm.loadingMap = true;
      return $gzGoogleMaps.onMap(vm.pairingId).then(map => {
        vm.map = map;

        return initializeMap().then(() => {
          return updateMarkers().then(() => {
            let onMapLoaded = _.get(vm.options, 'onMapLoaded');
            if (onMapLoaded) {
              onMapLoaded(vm.place);
            }
          });
        }).finally(() => {
          isInitialized = true;
        });
      }).finally(() => {
        vm.loadingMap = false;
      });
    }

    function handlePlaceChanged(place) {
      if (!isInitialized) {
        // Ignore place changed until we've set the initial address
        return;
      }

      vm.place = place;
      if (place) {
        vm.placeText = place.formatted_address;
      }
      updateAddressForm();
      updateMarkers();
    }

    function handlePlaceTextChanged() {
      // Clean up previous timer
      delete vm.place;
      if (updateGuessDebounceTimer) {
        $timeout.cancel(updateGuessDebounceTimer);
      }

      if (vm.placeText) {
        updateGuessDebounceTimer =  $timeout(updateGuess, 1000);
      }
    }
    ///////////////////////////////////////////////////////////
    // View Model
    function useBrowserLocation() {
      if (!('geolocation' in $window.navigator)) {
        return $q.reject();
      }

      $window.navigator.geolocation.getCurrentPosition(position => {
        let defaultLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        let geocoder = new $window.google.maps.Geocoder();
        geocoder.geocode({'latLng': defaultLocation}, (results, status) => {
          if (status === $window.google.maps.GeocoderStatus.OK && results[0]) {
            $rootScope.$applyAsync(() => {
              // Set the place directly here and let the places auto complete
              // directive call placeChanged() with additional info.
              vm.place = results[0];
              if (vm.place) {
                vm.placeText = vm.place.formatted_address;
              }
            });
          }
        });
      }, error => {
        console.error('Failed to get location');
      }, {timeout: 5000});
    }

    function useGuessLocation() {
      vm.place = vm.guess;
      vm.placeText = vm.place.formatted_address;
    }

    function toggleView() {
      vm.manualMode = !vm.manualMode;
      if (vm.manualMode) {
        delete vm.place;
        countryChanged();
      }
      else {
        vm.options.address = vm.address;
      }
    }

    function openAddresses() {
      $mdDialog.show({
        template: require('./select-address-dialog.jade'),
        controller: 'SelectAddressController',
        bindToController: true,
        controllerAs: 'vm',
        locals: {
          addresses,
        }
      })
        .then(data => {
          if (data) {
            vm.timezone = data.timezone;
            setAddress(data.address);
          }
        });
    }

    function isIncompletePlace() {
      return vm.addressForm.place.$dirty &&
        !vm.addressForm.$pending &&
        !isAddressValid();
    }

    ///////////////////////////////////////////////////////////
    // API
    function isValid() {
      if (!vm.addressForm) {
        return false;
      }

      if (!vm.addressForm.$valid) {
        return false;
      }

      if (!vm.hideName) {
        if (!vm.name || vm.name.trim() === '') {
          return false;
        }
      }

      if (!isAddressValid()) {
        return false;
      }

      return true;
    }

    function isAddressValid() {
      if (!vm.address.addressLine1 || vm.address.addressLine1.trim() === '') {
        return false;
      }

      if (!vm.address.locality || vm.address.locality.trim() === '') {
        return false;
      }

      if (!vm.address.region || vm.address.region.trim() === '') {
        return false;
      }

      if (vm.validators.postalCode.required && (!vm.address.postalCode || vm.address.postalCode.trim() === '')) {
        return false;
      }

      if (!vm.timezone) {
        return false;
      }

      if (!vm.address.country) {
        return false;
      }

      return true;
    }

    function getAddress() {
      let address = {
        address: vm.address,
        timezone: vm.timezone,
      };
      if (!vm.hideName) {
        address.name = vm.name.trim();
      }
      return address;
    }

    function setAddress(address) {
      delete vm.place;
      delete vm.placeText;
      vm.options.address = address;
      return updatePlace(address);
    }


    ///////////////////////////////////////////////////////////
    // Helpers
    function initializeMap() {
      let address = _.get(vm, 'options.address');
      return updatePlace(address);
    }

    function updatePlace(address) {
      resetMap();
      if (!address) {
        delete vm.place;
        delete vm.placeText;
        delete vm.guess;
        return updateMarkers();
      }

      return $gzGoogleMaps.getPlaceFromAddress(address).then(place => {
        vm.place = place;
        if (vm.editMode) {
          vm.placeText = place ? place.formatted_address : $gzGoogleMaps.getFormattedAddress(address);
          resetForm();
          if (place) {
            updateAddressForm();
          }
        }
        return updateMarkers().then(() => {
          return vm.place;
        });
      });
    }

    function updateMarkers() {
      clearMarkers();
      if (vm.address) {
        return updatePlaceMarker();
      }
      else {
        return updateAddressMarkers();
      }
    }

    function updatePlaceMarker() {
      vm.unknownLocation = false;
      if (!vm.place) {
        vm.unknownLocation = true;
        return $q.resolve();
      }

      let geometry = _.get(vm.place, 'geometry.location');
      if (!geometry) {
        vm.unknownLocation = true;
        return $q.resolve();
      }

      let location = _.get(vm, 'place.geometry.location');
      let position;
      if (_.isFunction(location.lat)) {
        position = {lat: location.lat(), lng: location.lng()};
      }
      else {
        position = location;
      }

      if (!position) {
        vm.unknownLocation = true;
        return $q.resolve();
      }

      markers.push(new $window.google.maps.Marker({
        position: position,
        map: vm.map,
      }));

      vm.map.setZoom(17);
      vm.map.panTo(position);

      return $q.resolve();
    }

    function updateAddressMarkers() {
      let addresses = _.get(vm.options, 'addresses', []);
      if (addresses.length === 0) {
        let address = _.get(vm.options, 'address');
        if (address) {
          addresses.push({address: address});
        }
      }

      if (addresses.length === 0) {
        return $q.resolve();
      }

      let promises = [];
      _.forEach(addresses, address => {
        if (address.address.addressLine1) {
          promises.push($gzGoogleMaps.getPlaceFromAddress(address.address).then(place => {
            if (!place) {
              return;
            }

            let location = _.get(place, 'geometry.location');
            if (!location) {
              return;
            }

            markers.push(new $window.google.maps.Marker({
              position: location,
              map: vm.map,
              title: address.name
            }));

            if (addresses.length === 1) {
              if (vm.map.getZoom() < 14) {
                vm.map.setZoom(14);
                vm.map.panTo(location);
              }
            }
          }));
        }
      });

      return $q.all(promises);
    }

    function updateGuess() {
      if (vm.place || !vm.placeText) {
        // If we already have a place or we do NOT have text to look up
        delete vm.guess;
        return;
      }

      $gzGoogleMaps.getPlaceFromLocation(vm.placeText).then(place => {
        if (place) {
          // TODO: Also make sure this is a valid PrintOS Address for us
          vm.guess = place;
        }
        else {
          delete vm.guess;
        }
      });
    }

    function updateAddressForm() {
      vm.address = $gzGoogleMaps.getAddressFromPlace(vm.place);
      vm.timezone = _.get(vm.place, 'gzTimeZone.value');
      if (_.get(vm, 'addressForm.place')) {
        vm.addressForm.place.$setDirty();
      }
      countryChanged();
    }

    function countryChanged() {
      if (!_.get(vm, 'address.country')) {
        return;
      }

      let country = getCountry(vm.address.country);

      if (country) {
        switch (country.isoCode) {
          case US_COUNTRY_CODE:
            vm.validators = US_VALIDATORS;
            break;
          case CANADA_COUNTRY_CODE:
            vm.validators = CANADA_VALIDATORS;
            break;
          default:
            vm.validators = DEFAULT_VALIDATORS;
            break;
        }

        // Semi-hack to trigger validation on region and postal code gz-regex-validator has
        // had a chance to pick up the new value (after appropriate digest cycle)
        $rootScope.$applyAsync(resetForm);
      }
    }

    function clearMarkers() {
      markers.forEach(marker => {
        marker.setMap(null);
      });
      markers.splice(0, markers.length);
    }

    function getCountry(isoCode) {
      return _.find(vm.countries, {isoCode: isoCode});
    }

    function resetMap() {
      if (vm.map) {
        vm.map.panTo({lat: 0, lng: 0});
        // vm.location = undefined;
        vm.map.setZoom(1);
      }
    }

    function resetForm() {
      let form = vm.addressForm;
      if (form) {
        if (form.state) {
          form.state.$setDirty();
          form.state.$setTouched();
          form.state.$validate();
        }

        if (form.postalCode) {
          form.postalCode.$setDirty();
          form.postalCode.$setTouched();
          form.postalCode.$validate();
        }
        form.$setSubmitted();
      }
    }

    ///////////////////////////////////////////////////////////
    // View Model
    function isPrintOSAddress(address) {
      vm.reasons = [];
      let isValid = true;
      if (_.get(address, 'addressLine1', '').trim() === '') {
        vm.reasons.push('uxf.uxf.invalidAddress');
        isValid = false;
      }

      if (_.get(address, 'locality', '').trim() === '') {
        vm.reasons.push('uxf.uxf.invalidLocality');
        isValid = false;
      }

      if (_.get(address, 'region', '').trim() === '') {
        vm.reasons.push('uxf.uxf.invalidRegion');
        isValid = false;
      }

      if (vm.validators.postalCode.required && _.get(address, 'postalCode', '').trim() === '') {
        vm.reasons.push('uxf.uxf.invalidPostalCode');
        isValid = false;
      }

      return isValid;
    }

    ///////////////////////////////////////////////////////////
    // Helpers
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/google-address/google-address.directive.js